<template>
    
    <div class="mobile-app-area" style="padding-bottom: 50px;">
        <div class="container">
            <div class="row align-items-center left-side-flex">
                <div class="col-lg-6 col-md-12">
                    <div class="about-img">
                        <img src="../../assets/images/Api-Model.png" data-aos="fade-up" alt="System API"
                            class="aos-init aos-animate">
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="about-content"><span class="sub-title">API & AI</span>
                        <h2>System, API & AI Model Integration</h2>
                        <p> Integrate third-party APIs, CRMs, ERPs, payment gateways, and AI models to unify operations
                            and improve performance. From voice recognition to intelligent data processing, we make your
                            systems smarter and more connected.</p>
                        <div class="features-text">
                            <h6>Industries</h6>
                            <p>Retail, finance, manufacturing, travel, real estate, and more.</p>
                                <h6>Key Benefits</h6>
                               <p>Centralized data, reduced manual work, AI automation, improved accuracy
                                Technologies: REST, GraphQL, Webhooks, Python, Node.js, AWS Lambda, Google AI APIs,
                                OpenAI API.
                            </p>
                            <h6>Technologies</h6>
                            <p> REST, GraphQL, Webhooks, Python, Node.js, AWS Lambda, Google AI APIs, OpenAI API.
                            </p>
                            <a href="/contact" class="nav-link" style="padding:0;"><button class="default-btn">Contact Us</button></a>
                        </div>

                        <!-- <div class="btn-box"><a href="/jexa/contact" class="default-btn">Start Free Trial</a><a
                            href="/jexa/features-one" class="link-btn">See All Features</a></div> -->
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>
<script>
export default {
  name: "ApiAi",
};
</script>